import { useCallback, useEffect, useState } from 'react';
import { useAppSelector } from 'store/hooks';
import { muteErrorAndFetching, useFetchOld } from 'hooks';
import { reverseTrialDeleteFunnelEligbility, } from 'features/premium/actions/reverseTrial';
import { Tier } from 'features/premium/entities';
import { selectAbFairPrice } from 'features/premium/selectors';
import { selectUserTier } from 'features/premium/selectors/tier';
import useCancellationOffer from 'features/promotions/hooks/useCancellationOffer';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useNavigateToFinalDeleteStep from './useNavigateToFinalDeleteStep';
const useNavigateToDeleteDiscountStep = (loadOnMount = true) => {
    const navigation = useMainStackNavigation();
    const { cancellationDiscountDataRef, fairPriceOffersRef, retry, isFetching } = useCancellationOffer(loadOnMount);
    const abFairPrice = useAppSelector(selectAbFairPrice);
    const navigateToFinalDeleteStep = useNavigateToFinalDeleteStep();
    const [isRetrying, setIsRetrying] = useState(false);
    const [reverseTrialEligbility, , , fetch] = useFetchOld(muteErrorAndFetching);
    useEffect(() => {
        if (loadOnMount) {
            fetch(reverseTrialDeleteFunnelEligbility());
        }
    }, []);
    const tier = useAppSelector(selectUserTier);
    const navigateToDeleteDiscountStep = useCallback(async () => {
        if (tier === Tier.free) {
            const timeout = new Promise((resolve) => {
                setTimeout(resolve, 3000);
            });
            setIsRetrying(true);
            const eligibility = reverseTrialEligbility ||
                (await Promise.race([
                    fetch(reverseTrialDeleteFunnelEligbility()),
                    timeout,
                ]));
            setIsRetrying(false);
            if (eligibility?.status === 'eligible') {
                navigation.navigateDeprecated('DeleteReverseTrialStart', {
                    reverseTrialTier: eligibility.reverseTrialTier,
                });
                return;
            }
        }
        if (abFairPrice && fairPriceOffersRef.current) {
            navigation.navigate('ManagePremiumSubscriptionFairPrice', {
                offers: fairPriceOffersRef.current.fairPriceOffers,
                currency: fairPriceOffersRef.current.currency,
                tier: tier,
                source: 'delete',
                callback: navigateToFinalDeleteStep,
            });
            return;
        }
        if (cancellationDiscountDataRef.current?.length) {
            navigation.navigateDeprecated('DeleteDiscount', {
                discountData: cancellationDiscountDataRef.current,
            });
        }
        else {
            await retry();
            if (cancellationDiscountDataRef.current?.length) {
                navigation.navigateDeprecated('DeleteDiscount', {
                    discountData: cancellationDiscountDataRef.current,
                });
            }
            else {
                navigateToFinalDeleteStep();
            }
        }
    }, [
        tier,
        abFairPrice,
        fairPriceOffersRef,
        cancellationDiscountDataRef,
        reverseTrialEligbility,
        navigateToFinalDeleteStep,
        retry,
    ]);
    return {
        navigateToDeleteDiscountStep,
        isFetchingDeleteDiscount: isFetching || isRetrying,
    };
};
export default useNavigateToDeleteDiscountStep;
